import { Component, ViewEncapsulation } from '@angular/core';
import { MatNavList, MatListItem, MatListItemIcon } from '@angular/material/list';
import { IfAuthorDirective } from '@portal-core/user-access/directives/if-author/if-author.directive';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'mc-app-nav',
    templateUrl: './app-nav.component.html',
    styleUrls: ['./app-nav.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatNavList, IfAuthorDirective, MatListItem, RouterLinkActive, RouterLink, MatIcon, MatListItemIcon]
})
export class AppNavComponent { }
